<template>
  <!--<b-container class="section-form-container">-->
  <b-card no-body>
    <b-card-header>
      <h4>Section Parameters</h4>
    </b-card-header>

    <b-card-body>
      <b-form>
        <rx-dropdown
          id="pavementType"
          v-model="pavementType"
          :options="pavementTypeOptions"
          title-text="Pavement Type"
          description="Select the pavement type that best describes your segment. The three options are (1) Flexible (HMA or other bituminous laters), (2) Rigid (Jointed Plain Concrete Pavement or JPCP, Jointed Reinforced Concrete Pavement or JRCP, or Continuously Reinforced Concrete Pavement or CRCP), and (3) Composite (HMA over rigid layer) "
          :validation="$v.pavementType"
        />

        <rx-number-input
          id="segmentLengthFt"
          v-model="segmentLengthFt"
          :placeholder="0"
          title-text="Segment Length (Ft)"
          description="Enter length of pavement to be rehabilitated. If your project contains multiple segments, this value should correspond to a single segment."
          :validation="$v.segmentLengthFt"
        />

        <rx-number-input
          id="segmentWidthFt"
          v-model="segmentWidthFt"
          :placeholder="0"
          title-text="Segment Width (Ft)"
          description="Indicate the total width of your segment for a typical cross section (include shoulders, if applicable). Note that the total width may be different (wider) than the actual width of road requiring rehabilitation."
          :validation="$v.segmentWidthFt"
        />

        <rx-radio
          id="intersectionPresent"
          v-model="intersectionPresent"
          :options="intersectionPresentOptions"
          title-text="Intersection Present"
          description="Indicate whether your segment includes an intersection. Presence of intersections or shoulders may result in RxPave providing additional considerations in the final report."
          :validation="$v.intersectionPresent"
        />

        <rx-radio
          id="twoWayTurnPresent"
          v-model="twoWayTurnPresent"
          :options="twoWayTurnOptions"
          title-text="Two Way Turn Present"
          description="Indicate the presence of two-way left turn lane(s) (TWLTL). As these lanes may experience different traffic loading conditions, RxPave may present additional considerations in the final report"
          :validation="$v.twoWayTurnPresent"
        />
      </b-form>
    </b-card-body>
  </b-card>
  <!--</b-container>-->
</template>

<script>

  import { mapFields } from "vuex-map-fields";
  import { mapMutations } from 'vuex'

  import RxDropdown from './inputComponents/RxDropdown.vue'
  import RxNumberInput from './inputComponents/RxNumberInput.vue'
  import RxRadio from './inputComponents/RxRadio.vue'
  import {isValidSection2a} from "../../../js/validation/projectValidation";

  export default {
    name: "Section2A",
    components: {
      RxDropdown: RxDropdown,
      RxNumberInput: RxNumberInput,
      RxRadio: RxRadio,
    },
    props: [
      '$v'
    ],
    data() {
      return {
        pavementTypeOptions: [
          {text: "Flexible (HMA or other bituminous layers)", value: 1},
          {text: "Rigid (JPCP, JRCP, or CRCP)", value: 2},
          {text: "Composite (HMA over rigid layer)", value: 3}
        ],
        intersectionPresentOptions: [
          {text: 'Unknown', value: -1},
          {text: 'No', value: 0},
          {text: 'Yes', value: 1}
        ],
        twoWayTurnOptions: [
          {text: 'Unknown', value: -1},
          {text: 'No', value: 0},
          {text: 'Yes', value: 1}
        ]
      };
    },
    computed: {
      ...mapFields('rx',[
        "currentProject",
        "currentProject.pavementType",
        "currentProject.segmentLengthFt",
        "currentProject.segmentWidthFt",
        "currentProject.intersectionPresent",
        "currentProject.twoWayTurnPresent"
      ])
    },
    updated: function () {
      this.setValid()
    },
    methods: {
      ...mapMutations('rx',[
        'validateProjectState',
        'setValidSection'
      ]),
      setValid(){
        console.log("Section 2A field validators match store validation:",
          isValidSection2a(this.currentProject) === !this.$v.$invalid);

        this.setValidSection({
          section: '2a',
          value: !this.$v.$invalid
        })
      }
    },
  }
</script>

<style scoped>

</style>